module.exports = __webpack_public_path__ + "static/palabok-364ed22af9bfb1da977101c1a2416a54.jpg";